<div
  class="breadcrumb-item-container display-flex grid-gap-10 align-items-center cursor-pointer"
  tabindex="0"
  (click)="open()"
  (keydown.enter)="open()"
>
  <app-icon [svg]="EIcon.ANGLE_RIGHT" [iconColor]="EColorPalette.cGray5" [iconHeight]="8" [iconWidth]="8"></app-icon>
  <div class="label pre-title text-color gray3">{{ item?.label }}</div>
</div>
